import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`




*, *::before, *::after{
    box-sizing:border-box;
}

html{
font-size:62.5%;
  //
  //    ::-webkit-scrollbar {
  //width: 15px;
  //&-track{
  //  background: #fff;
  //}
  //    &-thumb{
  //      border-radius: 5px;
  //    background: #009dcf;
  //        
  //        &:hover{
  //          cursor: pointer;
  //          background: #005869;
  //        }
  //    }
  //}

}

body{
    margin:0;
    padding: 0;
    color:#fff;
    font-family: 'PT Sans Narrow', sans-serif;
    font-size: 1.6rem;
    width:100%;
    height: 100vh;
    position:relative;
    background: #fff;
    overflow-x: hidden;
}


`;

export default GlobalStyle;
